import styles from './DashedLine.module.scss';

const DashedLine = () => {
	return <div className={styles.root} />;
};

export default DashedLine;
